import { CURRENT_ENV } from './appEnv.js';

// Proper domains for environments
const domainByEnv = {
    local: 'https://dev.',
    test: 'https://test.',
    dev: 'https://dev.',
    staging: 'https://staging.',
    production: 'https://www.',
};
const getSketchWebsite = (env) => `${domainByEnv[env] || ''}sketch.com`;
/**
 * Will output the correct Sketch website depending
 * on the environment
 *
 * @example
 * <Link href={`${SKETCH_WEBSITE}/home`}
 */
const SKETCH_WEBSITE = getSketchWebsite(CURRENT_ENV);

export { SKETCH_WEBSITE, getSketchWebsite };
